import { render, staticRenderFns } from "./list.view.vue?vue&type=template&id=2aecf3f8&scoped=true"
import script from "./list.view.vue?vue&type=script&lang=js"
export * from "./list.view.vue?vue&type=script&lang=js"
import style0 from "./list.view.vue?vue&type=style&index=0&id=2aecf3f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aecf3f8",
  null
  
)

export default component.exports